export default __webpack_public_path__ + "static/media/Leggings of the Starless Night.4fe9ff5e.jpg";